import React, { useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import InputTextElement from "../../../Components/UiComponents/InputTextElement";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";
import MultiSelectElement from "../../../Components/UiComponents/MultiSelectElement";
import CalendarElement from "../../../Components/UiComponents/CalendarElement";
import { create, getSeq } from "../../../Services/clientService";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import _ from 'lodash';
import Loader from "../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";

export default function CreateNewStakeHolder(props) {
  // const [errors, setErrors] = useState({});
  const [visible, setVisible] = useState(false);
  const toastRef = useRef();
  const [clientType, setClientType] = useState([]);
  const [sectorType, setSectorType] = useState([]);
  const [clientClassificationType, setClientClassificationType] = useState([]);
  const [clientClassificationV3Type, setClientClassificationV3Type] = useState(
    []
  );
  const [relationshipOwnerType, setRelationshipOwnerType] = useState([]);
  const [boardSponsorType, setBoardSponsorType] = useState([]);
  const [countryListType, setCountryListType] = useState([]);
  const [businessUnitType, setBusinessUnitType] = useState([]);
  const [regionType, setRegionType] = useState([]);
  const [customer, setCustomer] = useState({});
  const [branchDetails, setBranchDetails] = useState([]);
  const [inlineReader, setInlineReader] = useState(false);
  const [loading, setLoading] = useState(false)
  const [branchIdFromLS, setBranchIdFromLS] = useState()
  const navigate = useNavigate()

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");

    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);

      // Setting customer ID state
      setCustomer(enduser);
      const branch = enduser.branch;
      setBranchIdFromLS(branch)
    } else {
      navigate("/login")
      localStorage.clear()
    }
    getAllDetails();
  }, [props?.custmerDetails]);
  useEffect(() => {
    getBranchDetails();
  }, [props?.branchDetails]);
  useEffect(() => {
    getCustomerDetails();
  }, [props?.customerTableData]);

  const getCustomerDetails = () => { };

  const getBranchDetails = () => {
    setBranchDetails(props?.branchDetails);
  };

  const getAllDetails = () => {
    let data = props?.custmerDetails?.reference_data;
    if (props?.custmerDetails?.reference_data && data.length !== 0) {
      const clientTypeData = data.find(
        (item) => item.option_names === "clientTypeV1"
      );
      if (clientTypeData && clientTypeData?.option_choice) {
        const activeOptions = clientTypeData.option_choice.filter(
          (option) => option.status === "active"
        );
        setClientType(activeOptions);
      }

      const sectorData = data.find((item) => item.option_names === "SectorV1");
      if (sectorData && sectorData?.option_choice) {
        const activeOptions = sectorData.option_choice.filter(
          (option) => option.status === "active"
        );
        setSectorType(activeOptions);
      }

      const ClientClassification = data.find(
        (item) => item.option_names === "ClientClassificationV1"
      );
      if (ClientClassification && ClientClassification?.option_choice) {
        const activeOptions = ClientClassification.option_choice.filter(
          (option) => option.status === "active"
        );
        setClientClassificationType(activeOptions);
      }

      const ClientClassificationV3 = data.find(
        (item) => item.option_names === "ClientClassificationV3"
      );
      if (ClientClassificationV3 && ClientClassificationV3?.option_choice) {
        const activeOptions = ClientClassificationV3.option_choice.filter(
          (option) => option.status === "active"
        );
        setClientClassificationV3Type(activeOptions);
      }
      const relationshipOwner = data.find(
        (item) => item.option_names === "RelationshipOwner"
      );
      if (relationshipOwner && relationshipOwner?.option_choice) {
        const activeOptions = relationshipOwner.option_choice.filter(
          (option) => option.status === "active"
        );
        setRelationshipOwnerType(activeOptions);
      }

      const boardSponsor = data.find(
        (item) => item.option_names === "BoardSponsor"
      );
      if (boardSponsor && boardSponsor?.option_choice) {
        const activeOptions = boardSponsor.option_choice.filter(
          (option) => option.status === "active"
        );
        setBoardSponsorType(activeOptions);
      }

      const countryList = data.find(
        (item) => item.option_names === "CountryList"
      );
      if (countryList && countryList?.option_choice) {
        const activeOptions = countryList.option_choice.filter(
          (option) => option.status === "active"
        );
        setCountryListType(activeOptions);
      }

      const businessUnit = data.find(
        (item) => item.option_names === "BusinessUnit"
      );
      if (businessUnit && businessUnit?.option_choice) {
        const activeOptions = businessUnit.option_choice.filter(
          (option) => option.status === "active"
        );
        setBusinessUnitType(activeOptions);
      }

      const region = data.find((item) => item.option_names === "Region");
      if (region && region?.option_choice) {
        const activeOptions = region.option_choice.filter(
          (option) => option.status === "active"
        );
        setRegionType(activeOptions);
      }
    }
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  const clearForm = () => {
    reset();
  };

  // Function to create new prompt
  const onSubmit = async (promptData) => {
    setLoading(true); 
    let newCheckData = {};
  
    try {
      const response = await getSeq(customer.customer);
      const branch = branchDetails.find(branch => branch._id === branchIdFromLS.branch_id);
  
      // Ensure response is valid and contains the necessary data
      if (response && response.data && response.data.length > 0) {
        const client_seq = response.data[0].client_seq;
  
        if (promptData && client_seq !== undefined) {
          newCheckData = {
            branch_id: promptData?.branch_name?._id || branchIdFromLS.branch_id,
            branch_name: promptData?.branch_name?.branch_name ||  branch.branch_name,
            business_developer: promptData?.firstname || null,
            client_status: promptData?.client_status?.label || null,
            createdBy_id: customer?.userid || null,
            createdBy_name: customer?.username || null,
            sector: promptData?.sector || [],
            client_classification: promptData?.client_classification || [],
            relationship_owner: promptData?.relationship_owner?.label || null,
            main_board_sponsor: promptData?.main_board_sponsor?.label || null,
            client_seq: client_seq + 1,
            target_income: promptData?.target_income || null,
            next_review: promptData?.next_review ? formatDate(promptData?.next_review) : null,
            client_name: promptData?.client_name || null,
            client_type: promptData?.client_type || null,
            customer_id: customer?.customer || null,
            selectedClientStatusIndex: 0,
          };
  
          // Create a new record with the prepared data
          const createResponse = await create(newCheckData);
  
          // Check for successful creation
          if (createResponse && createResponse.status === 200) {
            toastRef.current.showToast({
              type: "success",
              message: `${createResponse.data.message} Successfully`,
            });
            clearForm();
  
            // Call addStakeholder if conditions are met
            if (props?.inlineReader && createResponse.data.clientId) {
              props?.addStakeholder(newCheckData, createResponse.data.clientId);
            }
  
            setTimeout(() => {
              closePopup();
            }, 500);
          } else {
            toastRef.current.showToast({
              type: "error",
              message: "Error occurred while creating the record.",
            });
          }
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "Invalid prompt data or client sequence.",
          });
        }
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Failed to retrieve client sequence.",
        });
      }
    } catch (error) {
      // Handle any errors that occurred during the API calls
      toastRef.current.showToast({
        type: "error",
        message: 'An error occurred. Please try again or contact Admin.',
      });
    } finally {
      setLoading(false); 
    }
  };
  const closePopup = () => {
    reset();
    setVisible(false);
    props.onHide(false);
  };

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className='align-center justify-end pb-0'>
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
          <ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit(onSubmit)} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <Dialog
        header={_.find(props.clientSectionsNew, { section_name: "New Client" })?.display_name}
        visible={props.visible}
        position={props.position}
        onHide={() => {
          closePopup();
        }}
        footer={renderFooter()}
        className="width-46"
        draggable={false}
      >
        <div className="new-field">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.clientFieldsNew, { field_name: "Client Name" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="client_name"
                  control={control}
                  rules={{ required: "Stakeholder Name is required" }}
                  render={({ field }) => (
                    <InputTextElement id="client_name" {...field} />
                  )}
                />
                {errors.client_name && (
                  <small className="text-red-500 color-red">
                    {errors.client_name.message}
                  </small>
                )}
              </div>

            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.clientFieldsNew, { field_name: "Client Type" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="client_type"
                  control={control}
                  render={({ field }) => (
                    <MultiSelectElement
                      id="client_type"
                      {...field}
                      name="client_type"
                      options={clientType}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
                {errors.client_type && (
                  <small className="text-red-500 color-red">
                    {errors.client_type.message}
                  </small>
                )}
              </div>
            </div>
            {
              props.havingBranch && props.branchIdFromLS.branch_key == 'main' &&
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-4 pl-0">
                  <label className="form-label text-left">
                    {_.find(props.commonFields, { field_name: "Branch" })?.display_name}:
                  </label>
                </div>
                <div className="col pr-0">
                  <Controller
                    name="branch_name"
                    control={control}
                    rules={{ required: "Branch is required" }}
                    render={({ field }) => {
                      const options =
                        props?.branchDetails?.map((branch) => ({
                          value: branch,
                          label: branch.branch_name,
                        })) || [];

                      return (
                        <SingleSelectElement
                          id="branch_name"
                          {...field}
                          name="branch_name"
                          options={(options != undefined && options.length > 0) ? options : []}
                          optionLabel="label"
                          placeholder="-- Please select --"
                          maxSelectedLabels={1}
                          onChangeValue={(e) => field.onChange(e.value)}
                          className="w-full"
                        />
                      );
                    }}
                  />
                  {errors.branch_name && (
                    <small className="text-red-500 color-red">
                      {errors.branch_name.message}
                    </small>
                  )}
                </div>
              </div>
            }
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.commonFields, { field_name: "Sector" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="sector"
                  control={control}
                  render={({ field }) => (
                    <MultiSelectElement
                      id="sector"
                      {...field}
                      name="sector"
                      options={sectorType}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
                {errors.sector && (
                  <small className="text-red-500 color-red">
                    {errors.sector.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.clientFieldsNew, { field_name: "Client Classification" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="client_classification"
                  control={control}
                  render={({ field }) => (
                    <MultiSelectElement
                      id="client_classification"
                      {...field}
                      name="client_classification"
                      options={clientClassificationType}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
                {errors.client_classification && (
                  <small className="text-red-500 color-red">
                    {errors.client_classification.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.clientFieldsNew, { field_name: "Client Status" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="client_status"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <SingleSelectElement
                      id="client_status"
                      {...field}
                      name="client_status"
                      options={(clientClassificationV3Type != undefined && clientClassificationV3Type.length > 0) ? clientClassificationV3Type : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
                {errors.client_status && (
                  <small className="text-red-500 color-red">
                    {errors.client_status.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.commonFields, { field_name: "Business Developer" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="firstname"
                  control={control}
                  render={({ field }) => {
                    const options =
                      props?.branch?.map((branch) => ({
                        value: `${branch.firstname} ${branch.surname}`,
                        label: `${branch.firstname} ${branch.surname}`,
                      })) || [];

                    return (
                      <SingleSelectElement
                        id="firstname"
                        {...field}
                        name="firstname"
                        options={(options != undefined && options.length > 0) ? options : []}
                        optionLabel="label"
                        placeholder="-- Please select --"
                        maxSelectedLabels={1}
                        onChangeValue={(e) => field.onChange(e.value)}
                        className="w-full"
                      />
                    );
                  }}
                />
                {errors.firstname && (
                  <small className="text-red-500 color-red">
                    {errors.firstname.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.commonFields, { field_name: "Relationship Owner" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="relationship_owner"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <SingleSelectElement
                      id="relationship_owner"
                      {...field}
                      name="relationship_owner"
                      options={(props.relationshipOwner != undefined && props.relationshipOwner.length > 0) ? props.relationshipOwner : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
                {errors.relationship_owner && (
                  <small className="text-red-500 color-red">
                    {errors.relationship_owner.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.commonFields, { field_name: "Main Board Sponsor" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="main_board_sponsor"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <SingleSelectElement
                      id="main_board_sponsor"
                      {...field}
                      name="main_board_sponsor"
                      options={(props.relationshipOwner != undefined && props.relationshipOwner.length > 0) ? props.relationshipOwner : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
                {errors.main_board_sponsor && (
                  <small className="text-red-500 color-red">
                    {errors.main_board_sponsor.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.clientFieldsNew, { field_name: "Target Income" })?.display_name + ' (' + (props.currency ? props.currency : '£') + ')'}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="target_income"
                  control={control}
                  render={({ field }) => (
                    <InputTextElement id="target_income" {...field} />
                  )}
                />
                {errors.target_income && (
                  <small className="text-red-500 color-red">
                    {errors.target_income.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {_.find(props.commonFields, { field_name: "Next Review" })?.display_name}:
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="next_review"
                  control={control}
                  render={({ field }) => (
                    <CalendarElement id="next_review" {...field} />
                  )}
                />
                {errors.next_review && (
                  <small className="text-red-500 color-red">
                    {errors.next_review.message}
                  </small>
                )}
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </div>
  );
}
